document.addEventListener("DOMContentLoaded", function () {
    function updateFreeShippingMessage() {
        var priceElement = document.querySelector('.current-price'); 
        var freeShippingMessage = document.getElementById("free-shipping-message");

        if (!priceElement) return;

        // Extract price text
        var priceText = priceElement.innerText.trim();
        
        // Detect currency (assuming it’s part of the price text, e.g., "$50.00" or "€50.00")
        var isUSD = priceText.includes('$') && !priceText.includes('€'); // Adjust based on your currency symbol logic
        var priceValue = parseFloat(priceText.replace(/[^0-9.]/g, ''));

        // Show or hide the message based on eligibility (price >= 65 and currency is USD)
        if (isUSD && priceValue >= 65) {
            freeShippingMessage.style.display = "block";
        } else {
            freeShippingMessage.style.display = "none";
        }
    }

    // Initial check for free shipping message
    updateFreeShippingMessage();

    // MutationObserver to watch for changes in the price element
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                updateFreeShippingMessage();
            }
        });
    });

    var priceElement = document.querySelector('.current-price');
    if (priceElement) {
        observer.observe(priceElement, { childList: true, subtree: true });
    }

    // Fix URL duplication issue on variant selection and update message
    document.addEventListener("change", function (event) {
        if (event.target.closest('form')) {
            setTimeout(updateFreeShippingMessage, 500);

            // Prevent duplicate URL expansion
            if (history.replaceState) {
                const cleanUrl = window.location.origin + window.location.pathname; 
                history.replaceState(null, '', cleanUrl);
            }
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const galleryContainer = document.querySelector('.gallery-navigation--scroller');
    const zoomContainer = document.querySelector('.product-zoom--thumb-scroller');

    if (!galleryContainer && !zoomContainer) {
        console.log("Neither gallery nor zoom container found.");
        return;
    }

    const thumbnails = (galleryContainer || zoomContainer).querySelectorAll('.cst_imag_product-gallery--media-thumbnail');
    console.log('Number of thumbnails found:', thumbnails.length);

    const extraThumbnails = thumbnails.length - 5;
    if (extraThumbnails > 1) {
        console.log("More than 5 thumbnails found. Creating 'Show More' button.");

        // Hide extra thumbnails
        for (let i = 5; i < thumbnails.length; i++) {
            thumbnails[i].style.display = 'none';
        }

        const showMoreButton = document.createElement('button');
        showMoreButton.classList.add('show-more-images');
        showMoreButton.textContent = ` ${extraThumbnails} +`;
        showMoreButton.style.cssText = 'display:block; margin-top:10px; cursor:pointer; padding:8px 12px; border:1px solid #ccc; background:#fff; font-size:14px;';
        (galleryContainer || zoomContainer).appendChild(showMoreButton);

        showMoreButton.addEventListener('click', function () {
            console.log("Show More button clicked.");

            if (window.innerWidth > 767) {
                console.log("Opening PhotoSwipe popup with first image...");

                if (
                    window.ProductClickToZoom &&
                    typeof window.ProductClickToZoom === 'function' &&
                    window.mainProductGalleryInstance &&
                    window.mainProductGalleryInstance.settings
                ) {
                    const settings = window.mainProductGalleryInstance.settings;
                    const figures = document.querySelectorAll('[data-gallery-figure]');
                    const thumbnails = document.querySelectorAll('[data-gallery-thumbnail]');
                    const pswpRoot = document.querySelector('.pswp');

                    if (!figures.length || !pswpRoot) {
                        console.warn("Missing gallery figures or pswp root element.");
                        return;
                    }

                    const scrollY = window.scrollY;
                    const pswpInstance = new window.ProductClickToZoom({
                        settings: settings,
                        slides: Array.from(figures),
                        originalThumbnails: Array.from(thumbnails),
                        startIndex: 0,
                        selectGalleryIndex: typeof window.mainProductGalleryInstance.selectGalleryIndex === 'function'
                            ? window.mainProductGalleryInstance.selectGalleryIndex
                            : () => {}
                    });

                   pswpInstance.photoswipe.listen('close', function () {
    console.log("PhotoSwipe closed, restoring scroll and showing Show More button.");
    setTimeout(() => {
        window.scrollTo(0, scrollY);
        showMoreButton.style.display = 'block'; // ✅ This restores the Show More button
    }, 0);
});
                    pswpInstance.photoswipe.listen('afterChange', function () {
                        const currentItem = pswpInstance.photoswipe.currItem;
                        const isZoomable = currentItem.w > pswpInstance.photoswipe.viewportSize.x ||
                                           currentItem.h > pswpInstance.photoswipe.viewportSize.y;
                        pswpRoot.classList.toggle('pswp--zoom-allowed', isZoomable);
                    });

                    pswpInstance.photoswipe.listen('initialZoomInEnd', function () {
                        const currentItem = pswpInstance.photoswipe.currItem;
                        const isZoomable = currentItem.w > pswpInstance.photoswipe.viewportSize.x ||
                                           currentItem.h > pswpInstance.photoswipe.viewportSize.y;
                        pswpRoot.classList.toggle('pswp--zoom-allowed', isZoomable);
                    });
                } else {
                    console.warn("PhotoSwipe setup is not yet available.");
                }
            } else {
                // Mobile: show all thumbnails
                console.log("Mobile view: revealing all thumbnails.");
                for (let i = 5; i < thumbnails.length; i++) {
                    thumbnails[i].style.display = 'block';
                }
            }

            // Hide the Show More button
            showMoreButton.style.display = 'none';
        });

        // Re-show button when PhotoSwipe is closed (if needed)
        if (typeof closePopup === 'function') {
            const originalClose = closePopup;
            closePopup = function () {
                originalClose();
                console.log("PhotoSwipe closed, restoring 'Show More' button.");
                showMoreButton.style.display = 'block';
            };
        }

    } else if (extraThumbnails === 1) {
        thumbnails[5].style.display = 'inline-block';
    } else {
        console.log("Not enough thumbnails to require 'Show More' button.");
    }
});

document.addEventListener('DOMContentLoaded', () => {
  /* ------------------------------------------------------------------
     1)  MOBILE REPOSITIONING  (unchanged logic, jQuery → vanilla)
  ------------------------------------------------------------------ */
  const originalContainer = document.querySelector('.original-container');

  const handleReposition = () => {
    const mobile          = window.matchMedia('(max-width:768px)').matches;
    const gallery         = document.querySelector('.product-gallery.hover-zoom-enabled');
    const title           = document.querySelector('.product-main .product-title');
    const ratingBlock     = document.querySelector('.comman_age_ply_rating');

    if (!gallery || !title || !ratingBlock) return;

    if (mobile) {
      title.after(ratingBlock);          // insertAfter
      ratingBlock.after(gallery);        // keep order
    } else if (originalContainer) {
      if (!originalContainer.contains(gallery)) originalContainer.append(gallery);
      if (!originalContainer.contains(ratingBlock)) originalContainer.append(ratingBlock);
    }
  };

  handleReposition();
  window.addEventListener('resize', handleReposition, { passive:true });


  /* ------------------------------------------------------------------
     2)  MOVE JUDGE.ME RATING WRAPPER BEFORE CAROUSEL TITLE
         (was $(...).insertBefore(...))
  ------------------------------------------------------------------ */
  const moveJudgeMe = () => {
    const ratingWrap = document.querySelector('.jdgm-all-reviews-rating-wrapper');
    const carouselTitle = document.querySelector('.jdgm-carousel-title');
    if (ratingWrap && carouselTitle && ratingWrap.nextElementSibling !== carouselTitle) {
      carouselTitle.parentNode.insertBefore(ratingWrap, carouselTitle);
    }
  };

  /* Judge.me widgets load after DOMContentLoaded; observe DOM changes */
  const obs = new MutationObserver(moveJudgeMe);
  obs.observe(document.body, { childList:true, subtree:true });

  /* one immediate attempt in case elements are already present */
  moveJudgeMe();
});

document.addEventListener('DOMContentLoaded', function() {
    // Check if the screen width is greater than 767px
    if (window.matchMedia("(min-width: 768px)").matches) { // Using 768px to include 767.0001px and above
        // console.log('Custom gallery script: Running for devices >= 768px width.');

        const customGalleryFigures = document.querySelectorAll('.custom-gallery-figure');
        // console.log('Custom gallery script: Result of .custom-gallery-figure querySelectorAll:', customGalleryFigures.length, 'elements found.');

        if (customGalleryFigures.length === 0) {
            // console.log('Custom gallery script: No custom gallery figures found. Exiting.');
            return;
        }

        const pswpRootElement = document.querySelector('.pswp');
        // console.log('Custom gallery script: Result of .pswp querySelector:', pswpRootElement ? 'found' : 'NOT found');

        if (!pswpRootElement) {
            // console.warn('Custom gallery script: PhotoSwipe root element (.pswp) is NOT found. Please ensure PhotoSwipe HTML is in theme.liquid.');
            return;
        }

        let checkInstanceInterval = setInterval(function() {
            if (window.ProductClickToZoom && typeof window.ProductClickToZoom === 'function' &&
                window.mainProductGalleryInstance && window.mainProductGalleryInstance.settings) {

                clearInterval(checkInstanceInterval);
                const productGalleryInstanceSettings = window.mainProductGalleryInstance.settings;
                const selectGalleryIndexCallback = (typeof window.mainProductGalleryInstance.selectGalleryIndex === 'function')
                                                     ? window.mainProductGalleryInstance.selectGalleryIndex
                                                     : function() {};

                // console.log('Custom gallery script: ProductClickToZoom and ProductGallery settings retrieved. Attaching click listeners.');

                const allProductMediaFigures = document.querySelectorAll('[data-gallery-figure]');
                // console.log('Custom gallery script: Found allProductMediaFigures:', allProductMediaFigures.length);

                if (allProductMediaFigures.length === 0) {
                    // console.warn('Custom gallery script: No [data-gallery-figure] elements found on the page. PhotoSwipe might not work correctly.');
                }

                const originalThumbnailsForPswp = document.querySelectorAll('[data-gallery-thumbnail]');
                // console.log('Custom gallery script: originalThumbnailsForPswp (before passing to PCtZ):', originalThumbnailsForPswp);
                // console.log('Custom gallery script: originalThumbnailsForPswp count:', originalThumbnailsForPswp.length);

                if (originalThumbnailsForPswp.length === 0) {
                    // console.warn('Custom gallery script: No [data-gallery-thumbnail] elements found. Thumbnails in PhotoSwipe popup might not work.');
                }

                customGalleryFigures.forEach(figure => {
                    console.log('Custom gallery script: Attaching click listener to figure (CAPTURING PHASE):', figure);
                    figure.removeEventListener('click', handleCustomGalleryClick, true);
                    figure.addEventListener('click', handleCustomGalleryClick, true);
                });

                // Define the click handler function
                function handleCustomGalleryClick(e) {
                    // console.log('Custom gallery script: --- Click event handler STARTED (CAPTURING) ---');
                    // console.log('Custom gallery script: Click event target:', e.target);
                    // console.log('Custom gallery script: Click event currentTarget (the figure):', this);

                    e.preventDefault();
                    e.stopImmediatePropagation();

                    // console.log('Custom gallery script: Default prevented, immediate propagation stopped.');

                    const clickedFigure = this; // The <figure> element that was clicked

                    // --- NEW LOGIC: Calculate both startIndex (unfiltered) and displayIndex (filtered) ---
                    let startIndex = -1; // Index in the unfiltered allProductMediaFigures array
                    let displayIndex = -1; // Index in the filtered photoswipeSlides array

                    const skippedMediaTypes = ['video', 'external_video', 'model'];

                    let currentFilteredCount = 0; // Counter for the filtered array
                    for (let i = 0; i < allProductMediaFigures.length; i++) {
                        const figureElement = allProductMediaFigures[i];

                        if (figureElement === clickedFigure) {
                            startIndex = i; // Store the unfiltered index of the clicked figure
                        }

                        // Check if this element will be included in PhotoSwipe's internal slides
                        if (skippedMediaTypes.indexOf(figureElement.dataset.mediaType) === -1) {
                            if (figureElement === clickedFigure) {
                                displayIndex = currentFilteredCount; // Store the filtered index of the clicked figure
                            }
                            currentFilteredCount++;
                        }
                    }

                    // console.log('Custom gallery script: Original allProductMediaFigures count:', allProductMediaFigures.length);
                    // console.log('Custom gallery script: Calculated startIndex (unfiltered):', startIndex);
                    // console.log('Custom gallery script: Calculated displayIndex (filtered for PCtZ):', displayIndex);
                    // --- END NEW LOGIC ---


                    if (startIndex !== -1 && displayIndex !== -1) { // Both indices must be found
                        // Logic for scroll prevention
                        const scrollY = window.scrollY;
                        // console.log('Custom gallery script: Captured scrollY on open:', scrollY);

                        const pswpInstance = new window.ProductClickToZoom({
                            settings: productGalleryInstanceSettings,
                            slides: Array.from(allProductMediaFigures), // Pass the UNFILTERED array here
                            originalThumbnails: Array.from(originalThumbnailsForPswp),
                            startIndex: startIndex, // Pass the UNFILTERED startIndex
                            displayIndex: displayIndex, // <--- NEW: Pass the FILTERED displayIndex
                            selectGalleryIndex: selectGalleryIndexCallback
                        });
                        // console.log('Custom gallery script: new ProductClickToZoom called directly. Instance:', pswpInstance);

                        // Logic for scroll prevention on close
                        pswpInstance.photoswipe.listen('close', function() {
                            // console.log('Custom gallery script: PhotoSwipe close event fired. Attempting to restore scroll position.');
                            // pswpRootElement.classList.remove('pswp--open');
                            setTimeout(() => {
                                pswpRootElement.classList.remove('pswp--open');
                                window.scrollTo(0, scrollY);
                                console.log('Custom gallery script: Restored scroll position to:', scrollY);
                            }, 0);
                        });
                        pswpInstance.photoswipe.listen('destroy', function() {
                            // console.log('Custom gallery script: PhotoSwipe destroy event fired. Ensuring pswp--open is removed.');
                            pswpRootElement.classList.remove('pswp--open');
                        });
                        // Logic for zoom icon visibility
                        pswpInstance.photoswipe.listen('afterChange', function() {
                            // console.log('Custom gallery script: PhotoSwipe afterChange event fired.');
                            const currentItem = pswpInstance.photoswipe.currItem;
                            // console.log('Custom gallery script: Current PhotoSwipe item:', currentItem);
                            if (currentItem && currentItem.w && currentItem.h) {
                                const isZoomable = currentItem.w > pswpInstance.photoswipe.viewportSize.x || currentItem.h > pswpInstance.photoswipe.viewportSize.y;
                                // console.log('Custom gallery script: Current item dimensions:', currentItem.w, 'x', currentItem.h, 'Viewport:', pswpInstance.photoswipe.viewportSize.x, 'x', pswpInstance.photoswipe.viewportSize.y, 'Is zoomable:', isZoomable);
                                if (isZoomable) {
                                    pswpRootElement.classList.add('pswp--zoom-allowed');
                                    // console.log('Custom gallery script: Added pswp--zoom-allowed class.');
                                } else {
                                    pswpRootElement.classList.remove('pswp--zoom-allowed');
                                    // console.log('Custom gallery script: Removed pswp--zoom-allowed class (image not zoomable).');
                                }
                            } else {
                                console.warn('Custom gallery script: currentItem or its dimensions (w, h) are missing for zoom check.');
                            }
                        });

                        pswpInstance.photoswipe.listen('initialZoomInEnd', function() {
                            // console.log('Custom gallery script: PhotoSwipe initialZoomInEnd event fired.');
                            const currentItem = pswpInstance.photoswipe.currItem;
                            if (currentItem && currentItem.w && currentItem.h) {
                                const isZoomable = currentItem.w > pswpInstance.photoswipe.viewportSize.x || currentItem.h > pswpInstance.photoswipe.viewportSize.y;
                                if (isZoomable) {
                                    pswpRootElement.classList.add('pswp--zoom-allowed');
                                    // console.log('Custom gallery script: Added pswp--zoom-allowed on initialZoomInEnd.');
                                }
                            }
                        });

                    } else {
                        // console.warn('Custom gallery script: Clicked figure not found in original or filtered image slides. Cannot open PhotoSwipe.');
                    }
                    // console.log('Custom gallery script: --- Click event handler FINISHED ---');
                }

            } else {
                // console.log('Custom gallery script: Waiting for global ProductClickToZoom and ProductGallery settings...');
            }
        }, 100);
    } else {
        // console.log('Custom gallery script: Not running for devices <= 767px width.');
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const allButtons = document.querySelectorAll('.see-more-btn, .see-more-btn-1');

    allButtons.forEach(button => {
      button.addEventListener('click', () => {
        // find this button’s benefit items
        const parent = button.parentElement;
        const hiddenItems = parent.querySelectorAll('.extra-benefit');
        if (!hiddenItems.length) return;

        const isHidden = hiddenItems[0].classList.contains('hidden_12');

        hiddenItems.forEach(item => item.classList.toggle('hidden_12'));

        /*  ⬇️ use innerHTML so the <img> is parsed, not printed  */
        button.innerHTML = isHidden
          ? 'Show Less <img src="https://cdn.shopify.com/s/files/1/0400/9767/7479/files/upward-arrow.png?v=1750136299"  alt="Up arrow"   class="arrow-icon-up1">'
          : 'Show More <img src="https://cdn.shopify.com/s/files/1/0400/9767/7479/files/down-arrow.png?v=1750136299" alt="Down arrow" class="arrow-icon-dwn1">';
      });
    });
  });          

  document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded ✅');
  
  const videoContainers = document.querySelectorAll('.product-gallery--external_video');
  
  if (!videoContainers.length) {
    console.warn('No video containers found');
    return;
  }

  // Initialize all iframes with pointer-events: none
  videoContainers.forEach(container => {
    const iframe = container.querySelector('iframe');
    if (iframe) {
      iframe.style.pointerEvents = 'none';
      console.log('Initialized iframe with pointer-events: none');
    }
  });

  // Click handler - enable controls for 2 seconds
  videoContainers.forEach(container => {
    container.addEventListener('click', function(e) {
      const iframe = this.querySelector('iframe');
      if (!iframe) return;
      
      console.log('Container clicked - enabling controls');
      iframe.style.pointerEvents = 'auto';
      
      // Disable after 2 seconds
      setTimeout(() => {
        iframe.style.pointerEvents = 'none';
        console.log('Auto-disabled controls after 2s');
      }, 2000);
      
      // Prevent event from reaching slick slider (optional)
      e.stopPropagation();
    });
  });

  // Slick slider events (if using slick)
  const gallery = document.querySelector('.product-gallery--viewer');
  if (gallery && gallery.classList.contains('slick-initialized')) {
    gallery.addEventListener('beforeChange', function() {
      console.log('Slider changing - disabling all controls');
      videoContainers.forEach(container => {
        const iframe = container.querySelector('iframe');
        if (iframe) iframe.style.pointerEvents = 'none';
      });
    });
  }
});

/* Sticky add to cart */

document.addEventListener('DOMContentLoaded', () => {
  const stickyBar   = document.querySelector('.sticky-add-to-cart');

  /* -------- helper: show / hide with a single CSS class -------- */
  const showBar  = () => stickyBar && stickyBar.classList.add('is‑visible');
  const hideBar  = () => stickyBar && stickyBar.classList.remove('is‑visible');

  /* -------- scroll handler -------- */
  const onScroll = () => {
    const y            = window.scrollY;
    const winH         = window.innerHeight;
    const docH         = document.documentElement.scrollHeight;
    const isMobile     = window.innerWidth < 767;
    const minScroll    = isMobile ? 1300 : 650;   // when to appear
    const maxScrollGap = isMobile ? 150  : 100;   // when to disappear near footer

    if (y > minScroll && (y + winH) < (docH - maxScrollGap)) {
      showBar();
    } else {
      hideBar();
    }
  };

  /* run once + bind */
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* -------- Shop Pay override -------- */
  document.addEventListener('click', e => {
    const btn = e.target.closest('.shopify-payment-button__button--shoppay');
    if (!btn) return;                       // click wasn’t on a Shop Pay button

    e.preventDefault();                     // stop default Shop Pay flow
    const moreOptions = document.querySelector('.shopify-payment-button__more-options');
    moreOptions?.click();                   // open “More options” instead
  });
});

/* Rating above title star placement */
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const badges = document.querySelectorAll('.jdgm-prev-badge');

    badges.forEach(badge => {
      const oldText = badge.querySelector('.jdgm-prev-badge__text');
      if (oldText) oldText.remove();

      const stars = badge.querySelector('.jdgm-prev-badge__stars');
      if (!stars) return;

      stars.style.display = 'inline-block';

      const averageRating = badge.getAttribute('data-average-rating') || '0.0';
      const numberOfReviews = parseInt(badge.getAttribute('data-number-of-reviews'), 10) || 0;

      const existing = badge.querySelector('.new-jdgm-prev-badge__text');
      if (existing) existing.remove();

      const wrapper = document.createElement('div');
      wrapper.className = 'new-jdgm-prev-badge__text';
      wrapper.innerHTML = `${averageRating} `;

      wrapper.appendChild(stars);
      wrapper.append(` (${numberOfReviews}) rating`);

      badge.appendChild(wrapper);
    });
  }, 700); // Wait for elements to render properly
});

/* By default tab open and tab change */
function openTab(event, tabName) {
    // Hide all tab contents
    const tabContents = document.querySelectorAll('.tab-content');
    tabContents.forEach(content => {
        content.classList.remove('active');
    });

    // Remove active class from all buttons
    const tabButtons = document.querySelectorAll('.tab-button');
    tabButtons.forEach(button => {
        button.classList.remove('active');
    });

    // Show the current tab and set the button as active
    document.getElementById(tabName).classList.add('active');
    event.currentTarget.classList.add('active');
}
  document.addEventListener("DOMContentLoaded", function () {
  const firstTabButton = document.querySelector(".tab-button");
  if (firstTabButton) {
    firstTabButton.click(); // Simulate click to trigger your openTab() logic
  }
});